import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public getStates() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetStates`;
    return this.httpClient.get(url);
  }

  public getStandardComments(type) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetStandardComments?type=${type}`;
    return this.httpClient.get(url);
  }

  public getDxCodes() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetDxCodes`;
    return this.httpClient.get(url);
  }

  public getDepartments() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetDepartments`;
    return this.httpClient.get(url);
  }

  public getSpecimenTypes() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetAllSpecimenTypes`;
    return this.httpClient.get(url);
  }

  public getDxCodeMatches(searchString) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/GetDxCodeMatches?searchString=${searchString}`;
    return this.httpClient.get(url);
  }

  public getFedExByTrackingId(trackingId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lookup/FedExTrackingId?trackingId=${trackingId}`;
    return this.httpClient.get(url);
  }
}
